export const environment = {
  mockLogin: false,
  production: false,
  hmr: false,
  apiUrl: process.env['APIURL'] || 'DEF_A',
  tenant: process.env['TENANT'] || 'DEF_A',
  client_id: process.env['CLIENTID'] || 'DEF_A',
  response_type: process.env['RESPONSETYPE'] || 'DEF_A',
  redirect_uri: process.env['REDIRECTURI'] || 'DEF_A',
  response_mode: process.env['RESPONSEMODE'] || 'DEF_A',
  scope: process.env['SCOPE'] || 'DEF_A',
  googleApi: process.env['GOOGLEAPI'] || 'DEF_A',
};


